import React from 'react'
import { getImagePath } from '../../common/productImageUtils'
import styles from'./Styles/inventory-productInfo.scss'
import Image, { AddVideoDiv } from '../../common/product-image/ImageViewUpload';

export default function InventoryProductInfo(props) {
  return (
    <div className={ styles['inventory-productinfo']}>
        <div className={styles['image-holder']}>
          <div className={styles['img-rounded']}>
            <Image 
              smallImage={true}
              imageUrl={props.ImageUrl}
              isReadOnly={true}
              // src={getImagePath(props.ImageUrl)} alt='Product icon' 
            />
          </div>
        </div>
        <div className={styles['product-name']}>
            <span>
                {props.productName} &nbsp;
            </span>
        </div>
    </div>
  )
}
